import { CSSObject } from '@emotion/react'
import { AssetReference } from '@opallabs/cassini'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import getAssetOrientation from '../../../../helpers/functions/getAssetOrientation'
import { sharedColors } from '../../../sharedDisplays/sharedStyles/styles'

const contentWrapper: CSSObject = {
  margin: '0 16px 0 16px',
}

const linkAssetHeight: Record<string, string> = {
  mobileSingle: '180px',
  desktopSingle: '299px',
}

const getLinkAssetStyle = (hasAsset: boolean, display: string): CSSObject => ({
  border: sharedColors.border,
  borderRadius: display.includes('mobile') ? '10px 10px 0 0' : '14px 14px 0 0',
  height: hasAsset ? linkAssetHeight[display] : 0,
  width: display.includes('mobile') ? '343px' : '568px',
  img: {
    borderRadius: display.includes('mobile')
      ? '10px 10px 0 0'
      : '14px 14px 0 0',
    height: linkAssetHeight[display],
  },
})

const linkTitleStyle: CSSObject = {
  color: sharedColors.darkGreyText,
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.large,
  fontWeight: fontWeights.medium,
  padding: '2.5px 5px',
}

const getLinkDescriptionStyle = (isMobile: boolean): CSSObject => ({
  color: isMobile ? sharedColors.darkGreyText : sharedColors.medGreyText,
  fontFamily: fonts.helvetica,
  fontSize: isMobile ? fontSizes.medium : fontSizes.large,
  padding: '2.5px 5px',
})

const getLinkDomainStyle = (isMobile: boolean): CSSObject => ({
  color: sharedColors.medGreyText,
  fontSize: isMobile ? fontSizes.medium : fontSizes.large,
  padding: '2.5px 5px',
  fontFamily: fonts.helvetica,
})

const linkBorders: Record<string, string> = {
  mobileSingle: '10px',
  desktopSingle: '14px',
}

const getLinkStyle = (hasAsset: boolean, display: string): CSSObject => ({
  border: sharedColors.border,
  borderRadius: hasAsset
    ? `0 0 ${linkBorders[display]} ${linkBorders[display]}`
    : `${linkBorders[display]}`,
  padding: display.includes('mobile') ? '5.5px 7px' : '6.5px 7px',
  '.kuiper-input-textarea .kuiper-input-container, kuiper-input-textarea.kuiper-filled kuiper-input-container':
    {
      backgroundColor: 'white',
    },
  '.kuiper-input.kuiper-filled .kuiper-input-container, .kuiper-input.kuiper-focused .kuiper-input-container':
    {
      backgroundColor: 'white',
    },
  '.kuiper-icon-wrapper .kuiper-icon-twitter-desktop-website-card-url': {
    color: sharedColors.medGreyText,
  },
})

const galleryDimensions: Record<string, CSSObject> = {
  desktopSingle: {
    height: '320px',
    width: '568px',
  },
  mobileSingle: {
    maxHeight: '193px',
    width: '343px',
  },
}

const getGalleryContainer = (display: string): CSSObject => ({
  ...galleryDimensions[display],
  backgroundColor: sharedColors.border,
  borderRadius: display.includes('mobile') ? '10px' : '14px',
})

const getAssetStyles = (
  asset: AssetReference,
  isMobile: boolean
): { asset: CSSObject; assetBase: CSSObject } => {
  const orientation = getAssetOrientation(asset)
  const maxWidth = isMobile ? '343px' : '568px'
  const maxHeight = isMobile ? '342px' : '569px'
  return {
    assetBase: {
      borderRadius: isMobile ? '10px' : '14px',
      overflow: 'hidden',
      border: sharedColors.border,
      width: 'fit-content',
    },
    asset: {
      width: orientation === 'portrait' ? 'auto' : maxWidth,
      height: orientation === 'landscape' ? 'auto' : maxHeight,
      maxWidth: orientation === 'portrait' ? maxWidth : '',
      img: {
        width: orientation !== 'portrait' ? maxWidth : '',
        height: orientation !== 'landscape' ? maxHeight : '',
        marginBottom: '-2px',
      },
    },
  }
}

const styles = {
  contentWrapper,
  linkTitleStyle,
  getGalleryContainer,
  getAssetStyles,
  getLinkAssetStyle,
  getLinkStyle,
  getLinkDescriptionStyle,
  getLinkDomainStyle,
}

export { styles }
